import styled, { css } from "styled-components";

import { breakpoints, fontFamily, colors } from "../../../theme";

export const Card = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;

  background-color: ${colors.surface};
  border: 1px solid ${colors.form.border};
  border-radius: 12px;
  text-align: left;

  padding: 32px 20px 52px;

  ${(props) =>
    props.$expanded
      ? `
    width: 100%;
    height: auto;
  `
      : `
    flex: 0 0 auto;
    width: 320px;
    height: 460px;
    scroll-snap-align: start;
  `}

  @media only screen and (min-width: ${breakpoints.tablet}) {
    ${(props) =>
      props.$expanded
        ? ""
        : `
      width: 332px;
      height: 480px;
    `}
  }
`;

export const QuoteDecoration = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 5px;
  overflow: hidden;
  border-top-right-radius: 12px;
  pointer-events: none;

  img {
    display: block;
    height: 42px;
    width: auto;
  }
`;

export const CardHeader = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Avatar = styled.div`
  height: 48px;
  width: 48px;
  min-width: 48px;
  overflow: hidden;
  border-radius: 50%;
  background-color: ${colors.white};
`;

export const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
`;

export const nameStyles = css`
  font-family: ${fontFamily.bold};
  font-size: 1.25rem;
  line-height: 102%;
  color: ${colors.accentContent};
`;

export const Name = styled.span`
  ${nameStyles}
`;

export const NameLink = styled.a`
  ${nameStyles}
  align-self: flex-start;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: ${colors.linkHover.light};
  }
`;

export const Role = styled.span`
  font-family: ${fontFamily.medium};
  font-size: 0.95rem;
  line-height: 120%;
  color: ${colors.grey.darkMedium};
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow-y: ${(props) => (props.$expanded ? "visible" : "auto")};
`;

export const BodyText = styled.p`
  margin: 0;
  font-family: ${fontFamily.medium};
  font-size: 1rem;
  line-height: 150%;
  letter-spacing: -0.003em;
  color: ${colors.body};
`;
